export default __webpack_public_path__ + "static/media/ROUTE.37993341.png";